import { useCallback, useEffect, useRef } from "react";

/**
 * Input for an email footer, allowing rich text pasting and editing
 *
 * Use case:
 *   - Open HTML file in browser
 *   - Select all (Ctrl+A) and copy (Ctrl+C)
 *   - Paste (Ctrl+V) into this input to retain formatting
 */
export const EmailFooterInput = (props) => {
    const { htmlContent, setHtmlContent } = props;
    const editorRef = useRef(null);

    // Set initial content
    useEffect(() => {
        if (editorRef.current && htmlContent && !editorRef.current.innerHTML) {
            editorRef.current.innerHTML = htmlContent;
        }
    }, [htmlContent]);

    const handleInput = useCallback(() => {
        if (editorRef.current) {
            const content = editorRef.current.innerHTML;
            setHtmlContent(content);
        }
    }, [setHtmlContent]);

    // Handle rich text formatting on paste
    const handlePaste = useCallback((e) => {
        e.preventDefault();
        const html = e.clipboardData.getData("text/html");
        const text = e.clipboardData.getData("text/plain");

        const content = html || text;

        const selection = window.getSelection();
        if (!selection || !selection.rangeCount) {
            return;
        }

        const range = selection.getRangeAt(0);
        range.deleteContents();

        // Create a temporary container to parse HTML
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = content;

        // Insert the parsed content
        const fragment = document.createDocumentFragment();
        let node;
        while ((node = tempDiv.firstChild)) {
            fragment.appendChild(node);
        }

        range.insertNode(fragment);

        // Move cursor to end of inserted content
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);

        // Trigger input event to update React state
        const target = e.currentTarget;
        target.dispatchEvent(new Event("input", { bubbles: true }));
    }, []);

    return (
        <div>
            <div
                ref={editorRef}
                contentEditable
                onInput={handleInput}
                onPaste={handlePaste}
                style={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    minHeight: "200px",
                    padding: "8px",
                    overflowY: "auto",
                }}
            />
        </div>
    );
};
